<template>
  <div>
    <div class="accountInfo" v-for="item in tableData.bind" v-if="scope.row[item.bind]" >
      <el-tooltip v-if="item.content && item.content(scope.row)" :data-i="item.content " :content="item.content && item.content(scope.row)" placement="top">
        <i class="label iconfont" :class="[item.getStatus(scope.row), item.icon]" @click="click(item)"></i>
      </el-tooltip>
      <i v-else class="label iconfont" :class="[item.getStatus(scope.row), item.icon]" @click="click(item)"></i>
      <popoverText class="account" :line="1" :text="scope.row[item.bind]" :subText="scope.row[item.bind]"></popoverText>
      <!--<el-button icon="iconfont icon-Slice1" circle></el-button>-->
    </div>
  </div>
</template>
<script>
  import popoverText from '@/components/tools/popoverText.vue'
  import {statusList} from '@/common/dictionary'
  export default {
    props: {
      "tableData": Object,
      "scope": Object
    },
    components: {
      popoverText
    },
    data () {
      return {
        statusList: statusList
      }
    },
    computed: {},
    watch: {},
    mounted () {
    },
    methods: {
      click(item) {
        item.click && item.click(this.scope.row, this)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .accountInfo {
    display: flex;
    align-items:center;
    &+& {
      margin-top: 10px;
    }
    .label {
      color: #409eff;
      margin: 0 10px;
      font-size: 24px;
      line-height: 24px;
      &.warning {
        color: #e6a23c;
        cursor: pointer;
      }
      &.danger {
        color: #f56c6c;
      }
      &.death {
        color: #909399;
        cursor: pointer;
      }
    }
    .status {
      width: 14px;
      height:14px;
      border-radius: 50%;
      background: #00ff00;
      display: inline-block;
      vertical-align: middle;
    }
    .account {
      color: #310101;
      font-size: 16px;
    }
  }
</style>
